import React from "react";
import {useSupplierModel} from "../supplierModel";
import {AppDrawer} from "../../../../components/YhDrawer";
import {FormItemTypeEnum, IYhForm} from "../../../../components/YhFormBox/Types";
import {YhForm} from "../../../../components/YhFormBox";


export function DetailDrawer() {
    const {drawerVisible: visible, setDrawerVisible, selectedData} = useSupplierModel();
    const onCancel = () => {
        setDrawerVisible(false);
    }

    const formConfig: IYhForm = {
        labelCol: {span: 6},
        disabled: true,
        formValues: selectedData,
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "分支",
                fieldName: "branch",
                span: 24,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "版本",
                fieldName: "ver",
                span: 24,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "启用",
                fieldName: "enable",
                span: 24,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "编码",
                fieldName: "code",
                span: 24,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "分组编码",
                fieldName: "linkCode",
                span: 24,
                hidden: !selectedData?.linkCode
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "名称",
                fieldName: "name",
                span: 24,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "客户类型",
                fieldName: "categoryName",
                span: 24,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "级别",
                fieldName: "level",
                span: 24,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "联系人",
                fieldName: "contact",
                span: 24,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "联系电话",
                fieldName: "phone",
                span: 24,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "办公电话",
                fieldName: "tel",
                span: 24,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "传真",
                fieldName: "fax",
                span: 24,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "邮箱",
                fieldName: "email",
                span: 24,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "网站",
                fieldName: "website",
                span: 24,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "办公地址",
                fieldName: "address",
                span: 24,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "发票抬头",
                fieldName: "invoiceHeader",
                span: 24,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "营业执照号",
                fieldName: "businessLicenseNo",
                span: 24,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "开户行",
                fieldName: "bank",
                span: 24,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "账号",
                fieldName: "bankAccount",
                span: 24,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "邮寄地址",
                fieldName: "postAddress",
                span: 24,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "法人",
                fieldName: "corporation",
                span: 24,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "经营范围",
                fieldName: "businessScope",
                span: 24,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "状态",
                fieldName: "status",
                span: 24,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "备注",
                fieldName: "note",
                span: 24,
            }
        ]
    };
    return (
        <AppDrawer
            {...{
                title: "应用详情",
                visible,
                onCancel,
                showFooter: false
            }}
        >
            <YhForm {...formConfig}/>
        </AppDrawer>
    )
}
